import axios from 'axios';
import {
    GET_USERS,
    GET_USER_ROLES,
    get_request_config
} from '@/utils/system_constants/constant.js';

import {
    fetch_organization_users,
    has_current_organization
} from '@/services/organization_service.js';

function parse_api_data(payload) {
    if (typeof payload === 'string') {
        try {
            return JSON.parse(payload);
        } catch (error) {
            if (error instanceof SyntaxError) {
                return {};
            }
            throw error;
        }
    }

    return payload || {};
}

function unwrap_items(payload) {
    const response_data = parse_api_data(payload?.data ?? payload);

    const items =
        response_data.data ||
        response_data.projects ||
        response_data.users ||
        response_data;

    return Array.isArray(items) ? items : [];
}

function get_user_name(user = {}) {
    const full_name = [
        user.first_name,
        user.last_name
    ]
        .filter(Boolean)
        .join(' ')
        .trim();

    return full_name || user.email || 'Unnamed User';
}

function map_user(profile = {}) {
    const user = profile.user || profile || {};
    const role = user.role || {};

    const mapped_user = {
        id: profile.user_id || user.id,
        profile_id: profile.profile_id,
        first_name: user.first_name || '',
        last_name: user.last_name || '',
        name: get_user_name(user),
        email: user.email || '',
        role: role.role || role || 'User',
        role_id: role.id || user.role_id || null,
        phone_number: profile.phone_number || '',
        sms_number: profile.sms_number || '',
        whatsapp_number: profile.whatsapp_number || '',
        entity_type_id: profile.entity_type_id || '',
        entity_type_name: profile.entity_type_name || '',
        project_id: profile.project_id || null,
        is_active: profile.is_active ?? user.is_active
    };
    return mapped_user;
}

export async function fetch_users() {
    const payload = has_current_organization()
        ? await fetch_organization_users()
        : await axios.get(
            GET_USERS,
            get_request_config({
                params: {
                    page: 1,
                    page_size: 100
                }
            })
        );

    const response_data = parse_api_data(payload?.data ?? payload);
    const items = unwrap_items(payload);

    return {
        users: items
            .map(map_user)
            .filter((user) => user.id != null),

        pagination: response_data.pagination || null
    };
}

export async function fetch_roles() {
    const response = await axios.get(
        GET_USER_ROLES,
        get_request_config()
    );

    const response_data = parse_api_data(response.data);
    const roles = Array.isArray(response_data)
        ? response_data
        : Array.isArray(response_data.data)
            ? response_data.data
            : [];

    return roles.filter((role) => role?.role);
}
